import 'babel-polyfill'

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import 'components/form/form.scss'
import main from 'components/main.scss'



//must go last
